import React from 'react'
import { Flex, Table } from 'antd'
import CustomButton from 'components/atoms/custom-button'
import { useNavigate } from 'react-router-dom'
import BadgeItem from 'components/atoms/badge-item'
import { transactionBadgeValue } from 'constant'

// Konfirmasi manual untuk paket tertinggi (EXECUTIVE / INSTITUTIONAL) dinonaktifkan
// sementara; semua transaksi kembali memakai tombol detail/lanjut bayar.
// const manualSubscriptionPackages = ['EXECUTIVE', 'INSTITUTIONAL']

// export function isNeedManualApproval(record) {
//   return (
//     manualSubscriptionPackages.includes(record?.package_name) &&
//     record?.package_status === 'CUSTOMER_PENDING'
//   )
// }

const TransactionTable = ({ data }) => {
  const navigate = useNavigate()
  const columns = [
    {
      title: 'No. Faktur',
      dataIndex: 'invoice_number',
      key: 'invoice_number',
      render: (data) => <span>{data ? data : '-'}</span>,
      width: 200
    },
    {
      title: 'Nama',
      dataIndex: 'package_name',
      key: 'package_name'
    },
    {
      title: 'Status',
      dataIndex: 'payment_status',
      key: 'payment_status',
      width: 150,
      render: (data) => (
        <BadgeItem
          badgeType={transactionBadgeValue[data]?.badgeType}
          className={transactionBadgeValue[data]?.class}>
          <span>{transactionBadgeValue[data]?.label}</span>
        </BadgeItem>
      )
    },
    {
      title: 'Aksi',
      key: 'Aksi',
      render: (data) => (
        // isNeedManualApproval(data) ? (
        //   <CustomButton
        //     type="primary"
        //     className="py-[6px] px-[30px] w-full"
        //     onClick={() => onClickApproval(data)}>
        //     Aksi
        //   </CustomButton>
        // ) : (
        <CustomButton
          type={data?.payment_status === 'UNPAID' ? 'primary' : 'plain'}
          className="py-[6px] px-[30px] w-full"
          onClick={() => navigate(`/profile/transaction/${data?.id}/detail-transaction`)}>
          {data?.payment_status === 'UNPAID' ? 'Lanjut Bayar' : 'Lihat Detail'}
        </CustomButton>
      ),
      width: 80
    }
  ]

  return (
    <Flex gap="middle" className='overflow-x-auto' vertical>
      <Table
        columns={columns}
        dataSource={data}
        rowKey={(record) => record.id}
        pagination={false}
      />
    </Flex>
  )
}

export default TransactionTable
